import { LinkWrapper, useStyles } from "./styles";
import { LinkProps } from "./types";

export const Link = ({ text, align = "left", onClick, style }: LinkProps) => {
  const styles = useStyles();

  return (
    <LinkWrapper style={{ alignSelf: align, ...styles.wrapper, ...style }} onClick={onClick}>
      {text}
    </LinkWrapper>
  );
};
